import classcat from "classcat";
import React from "react";

import { Image } from "@touchtech/baselayer-ui";
import { TouchtechLogo } from "@touchtech/web-baselayer-ui";

import css from "./Logo.module.css";
import useManageLogo from "./hooks/useManageLogo";

type Props = {
  className?: string;
  onClick?: () => void;
  showLogo?: boolean;
  showPoweredBy?: boolean;
  logoClassName?: string;
};

function Logo({
  className,
  onClick,
  showLogo = true,
  showPoweredBy = true,
  logoClassName,
}: Props) {
  const { t, tenant, handleClick } = useManageLogo({ onClick });

  return (
    <div className={classcat([css.container, className])} onClick={handleClick}>
      <div className={css.brandContainer}>
        {tenant?.logoUrl && showLogo && (
          <Image
            src={tenant.logoUrl}
            alt={tenant.label}
            className={logoClassName}
          />
        )}
        {!tenant?.logoUrl && showLogo && tenant?.label && (
          <div>{tenant.label}</div>
        )}
      </div>
      {showPoweredBy && (
        <div
          className={classcat(["text-label-base", css.touchtechLogoContainer])}
        >
          {t("Powered by")} <TouchtechLogo className={css.touchtechLogo} />
        </div>
      )}
    </div>
  );
}

export default Logo;
